import React from 'react';
import diagram1 from '../assets/fgc-tms-trading-system.webp';
import diagram2 from '../assets/tms-trading-system.webp';
import fgcTmsLogo from '../assets/fgc-tms-logo.webp';
const CentralizedTradingHub = () => {
    return (
        <section className="w-full bg-[#F1F1F1] pt-20 pb-10">
            <div className="site-shell">
                {/* Header Text Box */}
                {/* <span><img src={tmsLogo} alt="TMS Logo" className="inline-block align-middle h-8 md:h-14 mr-2" /></span> */}
                <div className="text-center mb-12 md:mb-18">
                    <h2 className="font-oswald text-black text-3xl md:text-5xl font-bold uppercase leading-tight mb-6">
                        <span className="inline-flex items-center align-middle">
                            <img
                                src={fgcTmsLogo}
                                alt="FGC TMS"
                                className="h-[1.2em] md:h-[1.2em] relative translate-y-[-3px] w-auto inline-block"
                                loading="lazy"
                            />
                        </span>{' '}
                        : A CENTRALIZED TRADING, <br className="hidden md:block" />
                        OPERATIONS AND COMPLIANCE HUB
                    </h2>
                    <p className="font-inter text-gray-600 text-lg md:text-xl leading-relaxed max-w-4xl mx-auto">
                        FGC TMS consolidates your entire trading and post-trade world into a single system system, transforming your team from a manual and fragmented teams into proactive problem solvers and a well coordinated task force.
                    </p>
                </div>

                {/* Diagram Image */}
                <div className="w-full flex justify-center mb-12 md:mb-16">
                    <img
                        src={diagram1}
                        alt="FGC TMS Centralized Trading Hub Diagram"
                        className="w-full h-auto md:px-10 max-w-full"
                        loading="lazy"
                    />
                </div>

                {/* Diagram Image */}
                <div className="w-full flex justify-center mb-12 md:mb-10">
                    <img
                        src={diagram2}
                        alt="FGC TMS Centralized Trading Hub Diagram"
                        className="w-full h-auto md:px-10 max-w-full"
                        loading="lazy"
                    />
                </div>

                {/* Footer Quote */}
                <div className="text-center ">
                    <p className="font-inter text-gray-700 text-lg md:text-2xl font-medium">
                        "Transform your team into an efficient, coordinated fixed income trading team."
                    </p>
                </div>
            </div>
        </section>
    );
};

export default CentralizedTradingHub;
